import { FunctionComponent } from 'react';
import { useRouteError } from 'react-router';
import ErrorMessage from './ErrorMessage';
import NotFound from '../../pages/NotFound';
import { isNotFoundError } from './NotFoundError';

const RouteErrorBoundary: FunctionComponent = () => {
	const error = useRouteError();

	if (isNotFoundError(error)) {
		return <NotFound message={error.message ?? undefined} />;
	}

	const errorMessage = error instanceof Error ? error.message : 'Ett fel har uppstått';
	return <ErrorMessage message={errorMessage} />;
};

export default RouteErrorBoundary;
